import { ErrorHandler, Injectable, inject } from '@angular/core';
import { TelemetryService } from '../telemetry/telemetry.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private telemetry = inject(TelemetryService);

  handleError(error: unknown): void {
    this.telemetry.trackException(error);
    console.error('Unhandled error:', error);
  }
}
